import { Button } from "@qw/ui";
import { type ComponentProps, type FC, useCallback } from "react";

import { useCreateDraft } from "../providers/use-create-draft";

export interface EmailLinkProps extends ComponentProps<typeof Button> {
  to: string | string[];
}

export const EmailLink: FC<EmailLinkProps> = ({ to, children, ...props }) => {
  const [createDraft, { loading: isCreateDraftLoading }] = useCreateDraft();

  const handleClick = useCallback(() => createDraft({ to: Array.isArray(to) ? to : [to] }), [createDraft, to]);

  return (
    <Button size="sm" variant="link" onClick={handleClick} disabled={isCreateDraftLoading} {...props}>
      {children ?? (Array.isArray(to) ? to.join(", ") : to)}
    </Button>
  );
};
